import React from 'react';
import styles from './Buttonpreloader.module.css';

/**
 * Compact Tabex-branded loader for buttons and tight UI slots.
 * variant: 'onDark' (white/gold on primary buttons) | 'onLight' (navy/gold on light surfaces)
 */
const Buttonpreloader = ({ variant = 'onDark', size = 18, className = '' }) => {
    const dim = typeof size === 'number' ? `${size}px` : size;

    return (
        <span
            className={`${styles.root} ${variant === 'onLight' ? styles.onLight : styles.onDark} ${className}`.trim()}
            style={{ width: dim, height: dim, fontSize: dim }}
            role="status"
            aria-label="Loading"
            aria-busy="true"
        >
            <span className={styles.ring} aria-hidden="true" />
            <span className={styles.core} aria-hidden="true">
                <span className={styles.mark}>T</span>
            </span>
        </span>
    );
};

export default Buttonpreloader;
